import React, { useState, useEffect } from 'react';
import { DataGridIdentifiers, DatagridPremiumUi } from '../../Interface';
import { dataGridPremiumColumns } from '../../../utils/helper';
import dashboardService from '../../../service/dashboard.service';

const DashboardReports = ({ refetch, values, viewField, operatorsDisabled }) => {
  const { refetchTable, setRefetchTable } = refetch;
  const { selectedValues, setSelectedValues } = values;

  const [reports, setReports] = useState({ rows: [], rowCount: 0 });
  const [rowSelectionModel, setRowSelectionModel] = useState([]);

  const initialState = {
    filter: {
      filterModel: {
        items: [
          {
            field: 'deletedBy',
            operator: 'isEmpty',
          },
        ],
        logicOperator: 'and',
      },
    },
    sorting: {
      sortModel: [],
    },
    pagination: {
      paginationModel: {
        pageSize: 25,
        page: 0,
      },
    },
    density: 'compact',
  };

  useEffect(() => {
    if (operatorsDisabled) {
      setRowSelectionModel([]);
    }
  }, [operatorsDisabled]);

  useEffect(() => {
    if (!Object.keys(selectedValues).length) {
      setRowSelectionModel([]);
    }
  }, [selectedValues]);

  const getList = (gridState) => {
    dashboardService.getDashboardList(gridState).then((data) => {
      setReports(data);
      setRefetchTable(false);
    });
  };

  const columns = dataGridPremiumColumns([
    {
      field: 'name',
      type: 'string',
      headerName: 'Név',
    },
    {
      field: 'type',
      type: 'string',
      headerName: 'Típus',
    },
  ]);

  return (
    <div className="flex overflow-hidden m-4">
      <div className="h-full w-full overflow-x-auto">
        <div className="inline-block w-full border-b border-gray-200 align-middle mt-4 overflow-y-auto overflow-x-auto">
          <DatagridPremiumUi
            datagridIdentifier={DataGridIdentifiers.dashboardReports}
            datagridInitialState={initialState}
            dataLoader={getList}
            rows={reports.rows}
            refetch={{ refetchTable, setRefetchTable }}
            rowCount={reports.rowCount}
            columns={columns}
            onRowClick={(rowData) => {
              if (!viewField) return;
              setSelectedValues(rowData.row);
            }}
            paginationAndfilterMode="server"
            onRowSelectionModelChange={(newRowSelectionModel) => {
              setRowSelectionModel(newRowSelectionModel);
            }}
            rowSelectionModel={rowSelectionModel}
            disableRowSelectionOnClick={!viewField}
            name={'Status'}
            height={750}
          />
        </div>
      </div>
    </div>
  );
};

export default DashboardReports;
